import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

export const getBranchesByCustomerEffect = (custId) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.PRIMARY}/GetBranchsByCustomer?customerKey=${custId}`,
  });
};
export const getUserTypeEffect = (userType) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetAllSaversUserType?userType=${userType}`,
  });
};
export const getTrailersListEffect = (params = {}) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      orderByColumn: 'createdon',
      orderBySort: 'DESC',
      ...params,
    },
    url: `${API.SAVERS}/GetAllTrailer`,
  });
};
export const getTrailerDetailsEffect = (trailerId) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetAllTrailer?trailerId=${trailerId}`,
  });
};
export const getUserRelationEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetUserRelation`,
  });
};
export const getTrailerRequestsEffect = ({ pageNo, trailerRequestStatusIDs }) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      orderByColumn: 'createdon',
      orderBySort: 'DESC',
      PageNumber: pageNo || 1,
      PageSize: 10,
      trailerRequestStatusIDs,
    },
    url: `${API.SAVERS}/GetTrailerRequest`,
  });
};
export const getTrailerRequestByIDEffect = (requestID) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetTrailerRequestById?trailerRequestId=${requestID}`,
  });
};
export const getTrailerRequestByTrailerIDEffect = (trailerID) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetTrailerRequestById?trailerID=${trailerID}`,
  });
};
export const getTrailerRequestByUserIDEffect = (userID, pageNo) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      orderByColumn: 'createdon',
      orderBySort: 'DESC',
      PageNumber: pageNo || 1,
      PageSize: 10,
      userId: userID,
    },
    url: `${API.SAVERS}/GetTrailerRequest`,
  });
};
export const getTrailerConditionStatusEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetTrailerStatus`,
  });
};
export const getTrailerRequestStatusEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetTrailerRequestStatus`,
  });
};
export const getUnitSizesEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetUnitSizes`,
  });
};
export const getRentalCompaniesEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetUnitRentalCompanies`,
  });
};
export const saveTrailerRequest = (data) => {
  return axiosInstance.request({
    data: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SAVERS}/SaveTrailerRequest`,
  });
};
export const saveTrailerMovement = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SAVERS}/SaveTrailerMovement`,
  });
};
export const saveShipmentData = (data) => {
  return axiosInstance.request({
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SAVERS}/CreateSaversShipments`,
  });
};
export const generateShipmentNoEffect = (userID) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GenerateShipmentNumber?UserId=${userID}`,
  });
};
export const getBranchDetails = (branchKey) => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentBranchAddress?BranchKey=${branchKey}`,
  });
};
export const getAllSaversCarriers = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetSaversCarrier`,
  });
};
export const getAllStatusEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetStatus`,
  });
};
export const getSupplyZoneEffect = (queryString = '') => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetAllSupplyZone${queryString ? queryString : ''}`,
  });
};
export const getAllLocationsEffect = (queryString = '') => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetAllLocation${queryString ? queryString : ''}`,
  });
};
export const getAllSupplyLocationIDEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentBranches`,
  });
};
export const getAllSupplyRegionEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetAllRegion`,
  });
};

export const getAllSupplyRscmEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetAllSaversUserType?userType=RSCM`,
  });
};

export const saveSupplyZone = (data) => {
  const updatedData = data.length === 1 ? data[0] : null;

  if (!updatedData) {
    throw new Error('Invalid data format. Expected an array with exactly one element.');
  }

  return axiosInstance.request({
    data: JSON.stringify(updatedData),
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SAVERS}/SaveSupplyZone`,
  });
};

export const getAllFreightCommodityIdEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GeFreightCommodity`,
  });
};

export const getAllUnitRentalCompanyIdEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetUnitRentalCompanies`,
  });
};

export const getAllNewUnitSizeIdEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SAVERS}/GetUnitSizes`,
  });
};

export const getRatingPreferenceEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetAllRatingPreferences`,
  });
};

export const getEquipmentTypesEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetAllEquipmentTypes`,
  });
};

export const getServiceLevelEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentServiceLevel?CustomerKey=6067&PageSize=10000&PageNumber=1`,
  });
};

export const getAccessorialsDetailsEffect = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.SHIPMENT}/GetShipmentAccessorialsForCustomer?shipmentKey=0`,
  });
};

export const saveTrailer = (data) => {
  const saveData = data.length === 1 ? data[0] : null;

  if (!saveData) {
    throw new Error('Invalid data format. Expected an array with exactly one element.');
  }

  return axiosInstance.request({
    data: JSON.stringify(saveData),
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.SAVERS}/SaveTrailer`,
  });
};

export const updateTrailerNote = (data) => {
  const saveData = data.length === 1 ? data[0] : null;

  if (!saveData) {
    throw new Error('Invalid data format. Expected an array with exactly one element.');
  }

  return axiosInstance.request({
    data: JSON.stringify(saveData),
    headers: { 'Content-Type': 'application/json' },
    method: 'put',
    url: `${API.SAVERS}/UpdateTrailerCondition`,
  });
};

let getShipmentListEffectCancelToken = () => {};
export const getShipmentListEffect = (data) => {
  getShipmentListEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentListEffectCancelToken = c;
    }),
    method: 'get',
    params: data,
    url: `${API.SAVERS}/GetTrailerShipment`,
  });
};

let updateShipmentStatusEffectCancelToken = () => {};
export const updateShipmentStatusEffect = (data) => {
  updateShipmentStatusEffectCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      updateShipmentStatusEffectCancelToken = c;
    }),
    data,
    method: 'post',
    url: `${API.SAVERS}/UpdateTrailerRequestStatus`,
  });
};
